import { FETCH_ERROR, HIDE_MESSAGE } from "appRedux/constants";
import { notification } from "antd";

export const hideCommonMessage = () => {
  return {
    type: HIDE_MESSAGE
  };
};

export const openNotificationWithIcon = (
  message,
  title = null,
  type = "success"
) => {
  const key = "updatable";

  if (title != null) {
    notification[type]({
      key,
      message: title,
      description: message,
      duration: 5
    });
  } else {
    notification[type]({
      key,
      description: message,
      duration: 5
    });
  }
};

export const handleError = errorMessage => {
  openNotificationWithIcon(errorMessage, `Error!`, "error");
  return { type: FETCH_ERROR, payload: errorMessage };
};
